import React, { JSX, useId } from "react";
import { CustomDateInput, CustomInput, CustomTextArea } from "./CustomInput";
import { InputLabel } from "./InputLabel";
import "react-phone-number-input/style.css";

import { InputError } from "../../screens/my-profile/InputError";
import { CustomPhoneInput } from "./CustomPhoneInput";
import { enviroment } from "../../../enviroment";

interface InputWrapperProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
}

export const InputWrapper = (props: InputWrapperProps) => {
  // @ts-any-go-brrr
  let label: any = <InputLabel>{props.label}</InputLabel>;
  let input;
  let rest;
  let error;
  // Confirm fixes (Clarity: dead clicks on the "Order details" labels): the
  // label and the field share an id, so a click on the label focuses the
  // field. The hook runs unconditionally (rules of hooks); off = the id is
  // never written = today's DOM, byte for byte.
  const generatedId = useId();
  const coupleLabel = enviroment.uxConfirmFixesEnabled;

  // A conditional child ({cond && <x/>}) can be false/null/undefined in the
  // children array - the optional chaining keeps the look-ups from throwing
  // on it (the classic confirm form's date field carries one in edit mode).
  function isInput(comp: JSX.Element) {
    return (
      comp?.type === CustomInput ||
      comp?.type === CustomTextArea ||
      comp?.type === CustomDateInput ||
      comp?.type === CustomPhoneInput
    );
  }

  function isLabel(comp: JSX.Element) {
    return comp?.type === InputLabel;
  }

  function isError(comp: JSX.Element) {
    return comp?.type === InputError;
  }

  if (Array.isArray(props.children)) {
    const childArray = props.children as JSX.Element[];
    label = childArray.find(isLabel);
    input = childArray.find(isInput);
    error = childArray.find(isError);
    rest = childArray.filter((x) => !isLabel(x) && !isInput(x) && !isError(x));
  } else if (props.children instanceof React.Component) {
    const child = props.children as JSX.Element;
    label = isLabel(child) ? child : null;
    input = isInput(child) ? child : null;
    error = isError(child) ? child : null;
  } else if (typeof props.children === "object") {
    // Single children.
    input = props.children;
  }

  if (coupleLabel && label && input && React.isValidElement(input)) {
    const inputProps = input.props as { id?: string };
    const fieldId = inputProps.id ?? generatedId;
    if (!inputProps.id) {
      input = React.cloneElement(input as React.ReactElement, { id: fieldId });
    }
    if (React.isValidElement(label)) {
      label = React.cloneElement(label as React.ReactElement, {
        htmlFor: fieldId,
      });
    }
  }

  return (
    <div className={"space-y-0.5 pb-3"}>
      {label}
      {input}
      {rest}
      {error}
    </div>
  );
};
